module.exports = __webpack_public_path__ + "static/media/marina-mobile.42919bfd.jpg";